import { numberToCurrency } from '../utils/prices';

interface getWhatsAppShareTexState {
    monthlyCost: any;
    maximumMortgageForMonthlyPayment: number | undefined;
}

export const getWhatsAppShareText = (state: getWhatsAppShareTexState, shareUrl: any) => {
    let shareText = '';

    shareText =
        shareText +
        `Ik heb mijn maximale hypotheek berekend op hypotheker.nl. Ik mag maximaal ${numberToCurrency(
            state?.maximumMortgageForMonthlyPayment || 0,
            true,
        )} lenen. Dat kost bruto per maand ${numberToCurrency(state.monthlyCost, true)}.`;

    shareText += ` Bekijk de berekening ${shareUrl}`;
    return shareText;
};
